module.exports = __webpack_public_path__ + "static/MuseoSans-100-af296c15277aa9cddbf1b7710470f135.woff2";